import { useContext } from "react";
import { ChargeTicketContext } from "../contexts/Tickets/ChargeTicket";

export function useChargeTicket() {
  const context = useContext(ChargeTicketContext);

  return context;
}
